var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    {
      class: [
        _vm.item.isException ? "exception-shipment" : "",
        _vm.compact ? "compact-row" : ""
      ],
      style:
        _vm.item.applyForCancelShipment && !_vm.item.deleteTime
          ? "background-color: yellow"
          : "",
      on: {
        click: function($event) {
          return _vm.$emit("update:expanded", !_vm.expanded)
        }
      }
    },
    [
      !_vm.isHideCheckBox &&
      _vm.isWarehouse &&
      ["active", "history"].includes(_vm.type)
        ? _c(
            "td",
            {
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  _vm.props.selected = !_vm.props.selected
                }
              }
            },
            [
              _c("v-checkbox", {
                attrs: {
                  "input-value": _vm.props.selected,
                  primary: "",
                  "hide-details": ""
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.index !== undefined
        ? _c(
            "td",
            { staticClass: "text-xs-center" },
            [
              _vm._v(_vm._s(_vm.index + 1) + "\n    "),
              _vm.isWarehouse && !_vm.isHideStar
                ? _c(
                    "v-icon",
                    {
                      attrs: {
                        small: "",
                        color: _vm.item.isCollection ? "red" : ""
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.toggleHighlight(_vm.item)
                        }
                      }
                    },
                    [_vm._v("\n    star\n  ")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "text-xs-left",
          staticStyle: { "white-space": "nowrap" }
        },
        [
          _vm.isOrganization
            ? _c("v-layout", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("user")) + ": ")]),
                _vm._v(_vm._s(_vm.item.userName))
              ])
            : _c("v-layout", [
                _c("strong", [_vm._v("Org: ")]),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        _vm.$emit(
                          "clickOrgId",
                          _vm.getOrgId(_vm.item.tenantKey)
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.getOrgId(_vm.item.tenantKey) +
                          " (" +
                          _vm.item.tenantName +
                          ")"
                      )
                    )
                  ]
                )
              ]),
          _vm._v(" "),
          _c("v-layout", [
            _c("strong", [_vm._v("ID: ")]),
            _vm._v(_vm._s(_vm.item._key))
          ]),
          _vm._v(" "),
          _vm.isOrganization && _vm.type === "active"
            ? _c("v-layout", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("type")) + ": ")]),
                _vm._v(_vm._s(_vm.$t("shipment")))
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.isOrganization || _vm.isWarehouse) && _vm.siteName
            ? _c("v-layout", [
                _c("strong", [_vm._v(_vm._s(_vm.$t("site")) + ": ")]),
                _vm._v(_vm._s(_vm.siteName))
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        {
          staticClass: "text-xs-left",
          staticStyle: { "white-space": "nowrap" }
        },
        [
          _c(
            "v-layout",
            [
              _c("v-layout", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(_vm.item.isExpedited ? "expedited" : "normal")
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                _vm.item.isTechShipment
                  ? _c(
                      "p",
                      {
                        staticStyle: {
                          color: "red",
                          "font-weight": "bold",
                          "font-size": "1.2rem"
                        }
                      },
                      [_vm._v("K")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.item.isPrinted && _vm.isOrganization && !_vm.item.deleteTime
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(data) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, data.on),
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.item.applyForCancelShipment
                                            ? "delete"
                                            : "lock"
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3111418621
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.item.applyForCancelShipment
                              ? _vm.$t("cancellationRequestSubmitted")
                              : _vm.$t("alreadyPrintLabel")
                          )
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.item.isForecastedPackages
            ? _c(
                "v-layout",
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(data) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, data.on),
                                  [_c("v-icon", [_vm._v("widgets")])],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4035929417
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("isThePackage")))])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.item.isForecastedSplitShipment
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(data) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, data.on),
                                      [
                                        _c("v-icon", { staticClass: "ml-1" }, [
                                          _vm._v("open_with")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2161591076
                          )
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("isTheNeedOpenPackage")))
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "text-xs-left" },
        [
          _vm._l(_vm.item.products, function(product, index) {
            return _c(
              "v-layout",
              { key: "product" + index },
              [
                !product.isPackageManagement
                  ? _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("ProductWidget", {
                          attrs: {
                            name: _vm.getUpcName(product),
                            condition: product.condition,
                            upc: product.upc,
                            pickedUpcs: _vm.pickedUpcs,
                            asin: _vm.isOrganization ? product.asin : null,
                            orderId: _vm.isWarehouse
                              ? null
                              : product.relatedOrder
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "info",
                                fn: function() {
                                  return [
                                    _c(
                                      "v-flex",
                                      {
                                        staticClass: "text-xs-right",
                                        staticStyle: { "white-space": "nowrap" }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(product.toShip) +
                                            "\n              "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "18px"
                                            }
                                          },
                                          [
                                            _vm.type === "active" &&
                                            _vm.pickedUpcs.includes(product.upc)
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer"
                                                    },
                                                    attrs: { small: "" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.cancelPickedItem(
                                                          product
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("pan_tool")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "upc",
                                fn: function() {
                                  return [
                                    _c("span", { staticClass: "ml-2" }, [
                                      _c(
                                        "a",
                                        {
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.$emit(
                                                "clickUpc",
                                                product.upc
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(product.upc))]
                                      )
                                    ])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                product.isPackageManagement
                  ? _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              "justify-space-between": "",
                              "align-center": ""
                            }
                          },
                          [
                            _c("v-layout", { staticClass: "text-sm-left" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(product.upc) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "text-xs-right",
                                staticStyle: { "white-space": "nowrap" }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(product.toShip) +
                                    "\n            "
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "18px"
                                    }
                                  },
                                  [
                                    _vm.type === "active" &&
                                    _vm.pickedUpcs.includes(product.upc)
                                      ? _c(
                                          "v-icon",
                                          {
                                            staticStyle: { cursor: "pointer" },
                                            attrs: { small: "" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.cancelPickedItem(
                                                  product
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("pan_tool")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _vm._v(" "),
          _vm.getService(_vm.item).length ||
          (_vm.item.IMEIRecords && _vm.item.IMEIRecords.length)
            ? _c(
                "v-layout",
                [
                  _c("span", [_vm._v(_vm._s(_vm.$t("otherServices")) + ":")]),
                  _vm._v(" "),
                  _vm._l(_vm.getService(_vm.item), function(service) {
                    return _c(
                      "v-chip",
                      { key: service, staticClass: "text-capitalize" },
                      [
                        _vm._v(
                          _vm._s(
                            (
                              _vm.otherServices.find(function(singleService) {
                                return (
                                  service.toLowerCase() ===
                                  singleService.value.toLowerCase()
                                )
                              }) || {}
                            ).displayName || service
                          )
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.item.IMEIRecords && _vm.item.IMEIRecords.length
                    ? _c("v-chip", [_vm._v("IMEI")])
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.item.warehouseNote && _vm.item.warehouseNote.length
            ? _c(
                "v-layout",
                [
                  _c("v-layout", { attrs: { column: "" } }, [
                    _c("div", [
                      _c("b", [_vm._v(_vm._s(_vm.$t("warehouseNote")) + ":")])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          whitespace: "pre-wrap",
                          "overflow-wrap": "break-word",
                          "max-width": "30vw"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.item.warehouseNote) +
                            "\n        "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.isOrganization
        ? _c("td", { staticClass: "text-xs-left" }, [
            _c("div", { staticClass: "shipment-id" }, [
              _vm._v(_vm._s(_vm.item.shipmentId))
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "text-xs-left" },
        [
          _c("div", { staticClass: "shipment-id" }, [
            _vm._v(
              _vm._s(
                _vm.type === "canceled" && _vm.item.cancelReason
                  ? _vm.item.cancelReason
                  : _vm.item.trackingNum
              )
            )
          ]),
          _vm._v(" "),
          _vm.isWarehouse && _vm.type === "active"
            ? _c(
                "v-layout",
                [
                  _vm.displayLabelSource(_vm.item) === 1
                    ? _c(
                        "div",
                        { staticClass: "label-source label-source--vite" },
                        [_vm._v("V")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.displayLabelSource(_vm.item) === 0
                    ? _c(
                        "div",
                        { staticClass: "label-source label-source--upload" },
                        [_vm._v("U")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.displayScanForm(_vm.item)
                    ? _c("v-icon", { attrs: { "pl-2": "", small: "" } }, [
                        _vm._v("barcode_reader")
                      ])
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("td", { staticClass: "text-xs-center" }, [
        _vm._v(_vm._s(_vm.item.packageQty))
      ]),
      _vm._v(" "),
      _vm.isOrganization
        ? _c("td", { staticClass: "text-xs-left" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.item.destination &&
                    (_vm.item.destination.name === "-- Other --"
                      ? _vm.item.destination.content
                      : _vm.item.destination.name)
                ) +
                "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "td",
        { staticClass: "text-xs-left" },
        _vm._l(_vm.getColumnTimes(_vm.item), function(time, i) {
          return _c("v-layout", { key: i, attrs: { row: "", wrap: "" } }, [
            _vm._v("\n      " + _vm._s(_vm.toTimestampString(time)) + "\n    ")
          ])
        }),
        1
      ),
      _vm._v(" "),
      _vm.type === "active" && !_vm.isHideBtns
        ? _c(
            "td",
            [
              _c(
                "v-layout",
                {
                  class: { "compact-actions": _vm.compact },
                  attrs: { "justify-center": "", wrap: "" }
                },
                [
                  _vm.item.isMeasureDimension && _vm.isOrganization
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled: !_vm.item.dimensions,
                            flat: "",
                            icon: ""
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.$emit(
                                "show-dimension-dialog",
                                _vm.item
                              )
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("edit")]),
                          _vm._v(" "),
                          _c("v-badge", {
                            staticClass: "editDimensionBadge",
                            attrs: {
                              value: _vm.checkNewDimensionChange(_vm.item),
                              color: "red"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "badge",
                                  fn: function() {
                                    return [
                                      _c("span", { staticClass: "badge" }, [
                                        _vm._v(_vm._s(_vm.$t("new")))
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2253888256
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(tooltip) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, tooltip.on),
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          flat: "",
                                          icon: "",
                                          disabled: !_vm.item.zipFile
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.getShipmentLabel(
                                              _vm.item
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            attrs: {
                                              color: _vm.item.isDownloaded
                                                ? "success"
                                                : ""
                                            }
                                          },
                                          [_vm._v("cloud_download")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1686842274
                      )
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              _vm.item.isDownloaded ? "reDownload" : "download"
                            )
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isWarehouse
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(tooltip) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, tooltip.on),
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              flat: "",
                                              icon: "",
                                              disabled:
                                                !_vm.item.zipFile ||
                                                !_vm.checkItemCanPrint(_vm.item)
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.printShipmentLabel(
                                                  _vm.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: _vm.item.isPrinted
                                                    ? "success"
                                                    : ""
                                                }
                                              },
                                              [_vm._v("print")]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3543560816
                          )
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(_vm.item.isPrinted ? "rePrint" : "print")
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(tooltip) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, tooltip.on),
                                  [
                                    _vm.isOrganization
                                      ? _c(
                                          "v-badge",
                                          {
                                            attrs: {
                                              value: _vm.checkNewComment(
                                                _vm.item
                                              ),
                                              color: "red",
                                              overlap: ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "badge",
                                                  fn: function() {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "badge"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("new")
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  flat: "",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.$emit(
                                                      "show-comments-active",
                                                      _vm.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("business")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4287156117
                      )
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("InternalOrganizations")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isOrganization || _vm.item.applyForCancelShipment
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(tooltip) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, tooltip.on),
                                      [
                                        _c("LoaderButton", {
                                          attrs: {
                                            buttonIcon: "delete",
                                            color: "secondary",
                                            promiseAwait: _vm.cancelShipment,
                                            promiseItem: _vm.item,
                                            flat: true
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            85542041
                          )
                        },
                        [
                          _vm._v(
                            "\n        " + _vm._s(_vm.$t("cancel")) + "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isOrganization ||
                  _vm.item.userKey === _vm.$store.getters.activeOrganization
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(tooltip) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, tooltip.on),
                                      [
                                        _vm.item.isMeasureDimension &&
                                        !_vm.item.isApproveShipment
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  disabled:
                                                    _vm.isOrganization &&
                                                    !_vm.item.dimensions,
                                                  flat: "",
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.$emit(
                                                      "show-dimension-dialog",
                                                      _vm.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [_vm._v("edit")]),
                                                _vm._v(" "),
                                                _c("v-badge", {
                                                  staticClass:
                                                    "editDimensionBadge",
                                                  attrs: {
                                                    value:
                                                      !!(
                                                        _vm.item.dimensions &&
                                                        _vm.item.dimensions
                                                          .length
                                                      ) && _vm.isOrganization,
                                                    color: "red"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "badge",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "badge"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "new"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          : _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  disabled:
                                                    _vm.isWarehouseOutboundDisabled ||
                                                    (_vm.item
                                                      .isMeasureDimension &&
                                                      !_vm.item
                                                        .isApproveShipment),
                                                  flat: "",
                                                  loading:
                                                    _vm.item.isProcessing,
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.$emit(
                                                      "show-confirm-dialog",
                                                      _vm.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("check_circle")
                                                ])
                                              ],
                                              1
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3598401565
                          )
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.$t(
                                  "" +
                                    (_vm.item.isMeasureDimension &&
                                    !_vm.item.isApproveShipment
                                      ? "measureDimension"
                                      : "confirm")
                                )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.type === "history" || _vm.type === "canceled") && !_vm.isHideBtns
        ? _c(
            "td",
            { staticClass: "text-xs-center" },
            [
              _c(
                "v-layout",
                { attrs: { "justify-center": "", wrap: "" } },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(tooltip) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, tooltip.on),
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          color: "primary",
                                          flat: "",
                                          icon: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.$emit(
                                              "show-details",
                                              _vm.item
                                            )
                                          }
                                        }
                                      },
                                      [_c("v-icon", [_vm._v("folder_open")])],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        990708206
                      )
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("details")) + "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(tooltip) {
                              return [
                                _c(
                                  "div",
                                  _vm._g({}, tooltip.on),
                                  [
                                    _vm.isOrganization
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              flat: "",
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.$emit(
                                                  "show-comments-history",
                                                  _vm.item
                                                )
                                              }
                                            }
                                          },
                                          [_c("v-icon", [_vm._v("business")])],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4291506566
                      )
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("InternalOrganizations")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.type === "canceled"
                    ? _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(tooltip) {
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, tooltip.on),
                                      [
                                        _vm.isOrganization
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  color: "primary",
                                                  flat: "",
                                                  disabled:
                                                    _vm.item
                                                      .isForecastedPackages,
                                                  icon: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.$emit(
                                                      "copy-shipment",
                                                      Object.assign(
                                                        {},
                                                        _vm.item,
                                                        {
                                                          isInitCanceledShipment:
                                                            _vm.type ===
                                                            "canceled"
                                                        }
                                                      )
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", [
                                                  _vm._v("content_copy")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2634066771
                          )
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("CopyShipment")) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.extraColumn ? _c("td", [_vm._t("extraColumn")], 2) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-311426d0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-311426d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OutboundShipmentRow.vue
// module id = null
// module chunks = 